const getToken = () => {
    try {
        return sessionStorage.getItem("token");
    }
    catch (exception) {
        console.error("Peek Error: sessionStorage error. Unable to read token value!!!");
    }
    return null;
};
const setToken = (token) => {
    try {
        sessionStorage.setItem("token", token);
    }
    catch (exception) {
        console.error("Peek Error: sessionStorage error. Unable to write token value!!!");
    }
};
const parseToken = (token) => {
    return JSON.parse(atob(token.split(".")[1]));
};

export { getToken, parseToken, setToken };
